export default __webpack_public_path__ + "static/media/resume.e564f5d4.jpg";